export default class TextNodeConst {
    static VAR_TEXT_IN='variableTextInput';    
  }


